import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

export interface IChangeRequestFormData {
  EntryId: number
  PartnerId: string
  PartnerName?: string
  Email: string
  FirstName: string
  LastName: string
  BusinessUnit: string[]
  Roles: string
  LeadPBM: number
  ManagerEmail: string
  ManagerFirstName: string
  ManagerLastName: string
  AssignmentPeriod: string

  // Fields from 1217
  TicketId: number
  TicketStatus: string
  RequestAction: string // Add | Delete
  SignId?: string

  SortOrder?: number
}

export const mapFormData = (data: IFormJBPHPContactChangeRequest): IChangeRequestFormData => {
  return {
    EntryId: data.EntryId,
    PartnerId: data.PartnerId,
    PartnerName: data.PartnerName,
    Email: data.Email,
    FirstName: data.FirstName,
    LastName: data.LastName,
    BusinessUnit: data.BusinessUnit ? data.BusinessUnit.split('/').filter(Boolean) : [],
    Roles: data.Roles,
    LeadPBM: data.LeadPBM,
    ManagerEmail: data.ManagerEmail,
    ManagerFirstName: data.ManagerFirstName,
    ManagerLastName: data.ManagerLastName,
    AssignmentPeriod: data.AssignmentPeriod,
    TicketId: data.TicketId,
    TicketStatus: data.TicketStatus,
    RequestAction: data.RequestAction,
    SignId: data.SignId,
    SortOrder: data.SortOrder,
  }
}
